export default () => ({
  showDrawer: false,
  chosenDeliveryTime: false,
});
